(function () {
  class CartRotatingUsps extends HTMLElement {
    constructor() {
      super();

      this._timer = null;
      this._activeIndex = 0;
      this._isVisible = false;
      this._visibilityObserver = null;
      this._handleVisibilityChange = this._handleVisibilityChange.bind(this);
    }

    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('.cart-rotating-usps__item'));
      this._interval = Number.parseInt(this.dataset.interval, 10) || 8000;
      this._prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._show(0);
      document.addEventListener('visibilitychange', this._handleVisibilityChange);

      if ('IntersectionObserver' in window) {
        this._visibilityObserver = new window.IntersectionObserver((entries) => {
          this._isVisible = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          this._syncRotation();
        });
        this._visibilityObserver.observe(this);
      } else {
        this._isVisible = window.getComputedStyle(this).display !== 'none';
        this._syncRotation();
      }
    }

    disconnectedCallback() {
      this._stop();
      this._visibilityObserver?.disconnect();
      this._visibilityObserver = null;
      document.removeEventListener('visibilitychange', this._handleVisibilityChange);
    }

    _show(index) {
      this._activeIndex = index;
      this._items.forEach(function (item, itemIndex) {
        item.toggleAttribute('data-active', itemIndex === index);
      });
    }

    _start() {
      if (this._timer) return;

      this._timer = window.setInterval(() => {
        this._show((this._activeIndex + 1) % this._items.length);
      }, this._interval);
    }

    _stop() {
      if (!this._timer) return;

      window.clearInterval(this._timer);
      this._timer = null;
    }

    _syncRotation() {
      if (!this._prefersReducedMotion && this._items.length > 1 && this._isVisible && !document.hidden) {
        this._start();
      } else {
        this._stop();
      }
    }

    _handleVisibilityChange() {
      this._syncRotation();
    }
  }

  if (!window.customElements.get('cart-rotating-usps')) {
    window.customElements.define('cart-rotating-usps', CartRotatingUsps);
  }
})();
